(function () {
  var ENDPOINT =
    "https://teddy-baldassarre.vercel.app/api/aircall-availability";

  function update(available) {
    var dots = document.querySelectorAll("[data-aircall-status]");
    for (var i = 0; i < dots.length; i++) {
      if (available) {
        dots[i].style.opacity = "1";
        dots[i].style.backgroundColor = "#22c55e";
        dots[i].classList.add("aircall-pulse");
      } else {
        dots[i].style.opacity = "0";
        dots[i].classList.remove("aircall-pulse");
      }
    }
  }

  function check() {
    fetch(ENDPOINT)
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        update(d.available);
      })
      .catch(function () {
        update(null);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", check);
  } else {
    check();
  }
})();
